import React from 'react';
import './Pagination.css';

function Pagination({ 
  page, 
  totalPages, 
  totalItems, 
  limit, 
  onPageChange, 
  onLimitChange 
}) {
  // Calculate limit options - always show 25, 50, 100, and "all" if there are items
  const limitOptions = [25, 50, 100];
  if (totalItems > 0) {
    // Only add "all" if total items is greater than 100
    if (totalItems > 100) {
      limitOptions.push('all');
    } else if (totalItems > 50 && totalItems <= 100) {
      // If total is between 50-100, show the actual number instead of "all"
      limitOptions.push(totalItems);
    }
  }

  return (
    <div className="pagination-wrapper">
      <div className="pagination-info">
        <span>Puslapis {page} iš {totalPages}</span>
        <span className="items-count">({totalItems} {totalItems === 1 ? 'įrašas' : 'įrašų'})</span>
      </div>

      <div className="pagination-controls">
        <div className="limit-selector">
          <label>Rodyti:</label>
          <select
            value={limit}
            onChange={(e) => {
              const newLimit = e.target.value === 'all' ? 'all' : parseInt(e.target.value);
              onLimitChange(newLimit);
              onPageChange(1); // Reset to first page when changing limit
            }}
            className="limit-select"
          >
            {limitOptions.map((opt) => {
              const value = opt === 'all' ? 'all' : opt;
              const label = opt === 'all' ? 'Visi' : opt.toString();
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              );
            })}
          </select>
        </div>

        <div className="page-buttons">
          <button
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={page === 1}
            className="btn btn-secondary btn-sm"
            title="Ankstesnis puslapis"
          >
            <span>←</span> Atgal
          </button>
          <button
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={page === totalPages}
            className="btn btn-secondary btn-sm"
            title="Kitas puslapis"
          >
            Pirmyn <span>→</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Pagination;
